export const permissionsMap = {
  sub_admin_manager: '/sub-admin-manager',
  customers: '/users',
  blog_manager: '/blogs',
  notification_managers: '/notifications',
  reports_manager: '/reports',
  about_us: '/static/about-us',
  contact_us: '/static/contact-us',
  faqs: '/static/faqs',
  privacy_policy: '/static/privacy-policy',
  terms_and_conditions: '/static/terms-and-conditions'
}
